<template>
  <div class="container">
    <el-container>
      <el-header><Header></Header></el-header>
      <el-container>
        <el-aside v-if="defaultActive !== '/login'"><Menu></Menu></el-aside>
        <el-main :class="{'router-main': defaultActive !== '/login'}">
          <router-view  class="main-router-view" :class="{'router-main-class': defaultActive == '/login'}"
        /></el-main>
      </el-container>
    </el-container>
  </div>
</template>

<script>
import Menu from "./Menu";
import Header from "./Header";

export default {
  components: { Menu, Header },
  computed: {
    defaultActive() {
      const path = this.$route.path;
      const re = /^(\/[^/]*)/g;
      return re.exec(path)[1];
    },
  },
};
</script>
<style scoped>
.container {
  min-height: 100%;
  background-color: #F3F3F3;
}
.container,
.is-vertical {
  padding: 0;
  margin: 0;
  min-height: 100vh;
}
.el-header {
  height: auto !important;
  padding: 0;
}
.router-main {
  padding: 0 20px;
  padding-top: 30px;
  padding-bottom: 50px;
}
.main-router-view {
  flex-grow: 1;
  overflow: hidden;
  height: 100%;
  padding: 30px 40px;
}
.el-main{
  padding: 0;
}
.router-main-class{
  display: flex;
  justify-content: center;
  height: auto;
  align-items: center;
}
</style>